<template>
  <v-btn text v-bind="$attrs" v-on="$listeners">
    Anuluj
  </v-btn>
</template>

<script>
export default {
  name: "CancelBtn",
}
</script>
